import { Validators } from '@angular/forms';

export class SolicitorPanelDetailsModel {
  panelSolicitor = {
    value: null,
    validation: Validators.compose([
      Validators.required,
    ])
  };
  mortgageDocs = {
    value: null,
    validation: Validators.compose([
      Validators.required,
    ])
  };
  sendCopy = {
    value: false,
    validation: Validators.compose([])
  };
}
